export const OtherDetailsForm = {
  title: 'Other details',
  display: 'Other',
  key: [],
  sections: [
    {
      columns: 2,
      fields: [
        {
          label: 'Comment',
          type: 'text',
          key: ['comment'],
          pos: {
            col: 1,
            row: 1,
            size: 1,
          },
        },
      ],
    },
  ],
}
